/* eslint no-underscore-dangle: [2, { "allow": [_id] }] */
import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { ListingSelector } from './listing-selector';
import { FormattedMessage } from 'react-intl';
import { tocByUseType } from '../app-mylistings/data/utils';
import SharedIntlProviderHOC from '../shared-components/hocs/sharedIntlProviderHOC';
import { QuestionFilled } from '../shared-components/icons';

export const ListingSettingsLeftPane = ({
  selectListing,
  selectedListing,
  listings,
  spaceTitle,
  spaceStreet,
  errorText
}) => {
  const zendeskLocale = SharedIntlProviderHOC.getZendeskLocale();
  return (
    <div className="flex column full-height settings-left-col">
      <div className="flex middle space-between">
        <a href={`/mylistings/${selectedListing._id}`}><i className="icon-back ico-sm margin-sm-right" />
          <FormattedMessage
            id="hosting.listing_settings_left_pane.back_link_text"
            defaultMessage="Back"
          />
        </a>
        <div className="visible-xs">
          <a href={`//support.peerspace.com/hc/${zendeskLocale}/articles/360017989772`}>
            <div className="link-gray flex middle">
              <QuestionFilled className="margin-md-right" />
              <div>
                <FormattedMessage
                  id="hosting.listing_settings_left_pane.faq"
                  defaultMessage="FAQ"
                />
              </div>
            </div>
          </a>
        </div>
      </div>
      <div className="h3 margin-xl-top">{spaceTitle}</div>
      <p className="margin-xl-bottom">{spaceStreet}</p>
      <div className="help-block text-danger text-left">{errorText}</div>
      <div className="hidden-xs">
        {
          listings.map((listing = {}) => {
            const { _id: listingId, use_type, title, is_instant_book_active: instantBookActive } = listing;
            const optionMsg = _.get(tocByUseType, [use_type, 'optionLabel'], false);
            const label = optionMsg ? <FormattedMessage {...optionMsg} /> : use_type;
            const selectedBtn = listingId === selectedListing._id && 'selected';
            return (
              <button key={listingId} onClick={() => { selectListing(listingId); }} className={`btn btn-block remove-click-styling option-btn ${selectedBtn || ''}`}>
                <div className="text-left">
                  <div>
                    <div className="flex space-between">
                      <div className="text-large">{label}</div>
                      { instantBookActive &&
                        <div>
                          <span className="green-dot"/>
                          <span className="on-label">
                            <FormattedMessage
                              id="hosting.listing_settings_left_pane.on"
                              defaultMessage="on"
                            />
                          </span>
                        </div>
                      }
                    </div>
                    <div className="text-large ellipsis">{title}</div>
                  </div>
                </div>
              </button>
            );
          })
        }
      </div>
      <div className="visible-xs">
        <ListingSelector
          selectedListingId={selectedListing._id}
          listingClickFn={selectListing}
          listings={_.keyBy(listings, '_id')}
        />
      </div>
    </div>
  );
};

ListingSettingsLeftPane.propTypes = {
  listings: PropTypes.array.isRequired,
  selectedListing: PropTypes.string.isRequired,
  selectListing: PropTypes.func,
  spaceTitle: PropTypes.string,
  spaceStreet: PropTypes.string,
  errorText: PropTypes.string
};
